import { signUserFunction } from './gallery-properties.flow'

import { LOW_OPACITY } from '../utils/shared-constants'

export default signUserFunction(calcHeaderContentMetaBackground)

function calcHeaderContentMetaBackground(_rawVal, calcProp) {
  const header_content_bg_type = calcProp('header_content_bg_type')

  const header_content_background = calcProp('header_content_background')
  const header_content_solid_background = calcProp('header_content_solid_background')
  const header_content_meta_background = header_content_bg_type === 'solid'
    ? header_content_solid_background
    : header_content_background

  const header_content_bg_opacity = calcProp('header_content_bg_opacity')
  const header_content_solid_bg_opacity = calcProp('header_content_solid_bg_opacity')
  const header_content_meta_opacity = header_content_bg_type === 'solid'
    ? header_content_solid_bg_opacity
    : header_content_bg_opacity

  const body_background_color = calcProp('body_background_color')
  return header_content_meta_opacity < LOW_OPACITY
    ? body_background_color
    : header_content_meta_background
}
